<template>
  <div class="d-flex flex-column">

    <div class="mb-2">
      <v-select clearable
                v-model="mainLocation"
                outlined
                dense
                hide-details="auto"
                :items="locations"
                :placeholder="$t('location.locationTop')"
                :disabled="locations.size === 0"
      />
    </div>
    <div>
      <v-select v-model="subLocation"
                outlined
                dense
                clearable
                hide-details="auto"
                :placeholder="$t('location.locationSub')"
                :items="sublocations"
                :disabled="sublocations.length === 0"
                @change="handleChange"
                no-data-text="''"
      />
    </div>
  </div>
</template>

<script>
import LocationService from '@/services/LocationService';

export default {
  name: 'LocationSelect',
  data: () => ({
    locationsData: [],
    mainLocation: null,
    subLocation: null,
  }),
  props: {
    value: {
      required: true,
    },
  },
  computed: {
    location: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

    locations() {
      return this.locationsData.map((sb) => ({
        text: sb.location.name,
        value: sb.location,
      }));
    },
    sublocations() {
      if (!this.mainLocation){
        return [];
      }
      const currentLocation = this.locationsData.find(
          (location) => location.location.id === this.mainLocation.id,
      );
      if (currentLocation?.subLocations) {
        return currentLocation.subLocations.map((sb) => ({
          text: sb.location.name,
          value: sb.location,
        }));
      }
      return [];
    },
  },
  methods: {

    handleChange(value) {
      this.location = value;
    },
    setLocation(newLocation){
      if (!newLocation) {
        this.mainLocation = null;
        this.subLocation = null;
      } else if (newLocation?.parentLocationId) {
        this.subLocation = newLocation;
        this.mainLocation = this.locationsData.find(
            (location) => location.location.id === newLocation.parentLocationId,
        ).location;
      } else {
        this.mainLocation = newLocation;
      }
    },
  },
  created() {
    LocationService.getLocationHierarchy()
        .then((res) => {
      this.locationsData = res.data.subLocations;
      this.setLocation(this.location);
    });
  },
};
</script>
